import React, { useState } from "react"

const RainyDay = () => {
   const [activeIndex, setActiveIndex] = useState(null)

   const toggleAccordion = () => {
      setActiveIndex((prevActiveIndex) => (prevActiveIndex === null ? 0 : null))
   }

   return (
      <div className='GrandOpen'>
         <div className={`accordion-item ${activeIndex === 0 ? "active" : ""}`}>
            <h1 onClick={toggleAccordion}>
               <img src={require("../../img/news/news01-1.jpg")} alt="" />
               [LCDC]   RAINY DAY IN LCDC
            </h1>
            <span>2023-08-07</span>
            {activeIndex === 0 && (
            <div>
               <img src={require("../../img/news/news01.jpg")} alt="" />
               <p>비 오는 날이 기다려지는 이유. 비가 내리는 날에는 LCDC에서 온전히 즐겨보세요. </p>
               <p style={{fontWeight:'bold'}}>1F 이페메라, 2F SHOP LCDC, 4F 바피에스에서 여름의 낭만을 느낄 수 있도록 이벤트를 선보입니다.</p>

               <img src={require("../../img/news/news01-1.jpg")} alt="" />
               <p>비가 내리는 날에는 이페메라에서 온전히 즐겨보세요 조금 더 여유로운 시간을 선물합니다. </p>
               <span>⟪ EVENT ⟫</span>
               <p>비가 내리는 날, 이페메라에 책과 노트북을 지참한 모든 분께 아메리카노 1회 리필을 제공해요.</p>
               <span>장소 ⎮ 1F 이페메라 </span>
               <span>기간 ⎮ 8월 1일(화) - 8월 31일(목)</span>
               <span>안내 ⎮ 1인 1메뉴 한함, 주말/주중 가능</span>

               <img src={require("../../img/news/news01-2.jpg")} alt="" />
               <p>비가 내리는 날에는 SHOP LCDC 에서 온전히 즐겨보세요. 무거워진 손이 그날만큼은 조금은 가벼워 질 수 있도록 배려해 드립니다. </p>
               <span>⟪ EVENT ⟫</span>
               <p>비가 내리는 날, SHOP LCDC에서 구매한 상품은 모두 무료 배송해 드려요. </p>
               <span>장소 ⎮ 2F SHOP LCDC</span>
               <span>기간 ⎮ 8월 1일(화) - 8월 31일(목)</span>
               <span>안내 ⎮ 주말/주중 가능</span>


               <img src={require("../../img/news/news01-3.jpg")} alt="" />
               <p>비가 내리는 날에는 바피에스에서 온전히 즐겨보세요. 당신의 취향에 따라 메뉴를 선택할 수 있습니다. </p>
               <span>⟪ EVENT ⟫</span>
               <p className="mb50">푸드 2종 [(Mero or Beef Wellington 중 택1) + (Prawn Pasta or Lasagna 중 택1)]  하우스 와인(Bottle) 택1 [화이트/레드/스파클링]  특별 세트 메뉴를 선보입니다. </p>
               <span>장소 ⎮ 4F 바피에스</span>
               <span>기간 ⎮ 8월 1일(화) - 8월 31일(목)</span>
               <span className="mb150">안내 ⎮ 세트메뉴 6만원, 16:00-22:30 주문 가능, 주말/주중 가능</span>

            </div>
            )}
         </div>
      </div>
   )
}

export default RainyDay
